// @ts-check
import React, { Component } from 'react';
import { Page, Row, Widget } from 'shared/containers/portal_layout';
import api from 'utils/api';
import LoadingContent from 'shared/components/LoadingContent';
import PatientMemberHeader from '../PatientMemberHeader';
import HForm, {
  TextField,
  PhoneMaskField,
  PlainSelectField,
  DateMaskField,
  PlainCountySelectionField,
  RadioGroupField,
} from 'shared/containers/portal_layout/HForm';
import { reduxForm, Field, formValueSelector } from 'utils/reduxFormWrapper';
import Errors from 'shared/components/Errors';
import FlashMessageActions from 'shared/actions/FlashMessageActions';
import { Link, browserHistory } from 'react-router';
import { decamelizeKeys } from 'humps';
import SpinnerButton from 'shared/components/SpinnerButton';
import PatientCoverageForm from 'shared/components/PatientCoverage/Form';
import { connect } from 'react-redux';

class Show extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = { patientMember: null };
    this.updatePatientMember = this.updatePatientMember.bind(this);
  }

  componentDidMount() {
    this.fetchPatientMember();
  }

  fetchPatientMember() {
    api.get(`/agent_portal/api/patient_members/${this.props.params.id}/edit`).then(response => {
      this.setState({ ...response.data });
    });
  }

  updatePatientMember(formValues) {
    return api
      .put(`/agent_portal/api/patient_members/${this.state.patientMember.id}`, {
        patient_member: decamelizeKeys(formValues),
      })
      .then(response => {
        FlashMessageActions.flashSuccess({ message: 'Patient successfully updated' });
        browserHistory.push(`/a/portal/patient_members/${this.state.patientMember.id}`);
        return null;
      });
  }

  render() {
    if (!this.state.patientMember) return <LoadingContent />;
    return (
      <FormifiedPresentationComponent
        patientActiveStatuses={this.state.patientActiveStatuses}
        persistedPatientMember={this.state.persistedPatientMember}
        states={this.state.states}
        form="editPatientMember"
        initialValues={this.state.patientMember}
        onSubmit={this.updatePatientMember}
        zip={this.props.zip}
      />
    );
  }
}

const PresentationComponent = ({
  persistedPatientMember,
  patientActiveStatuses,
  handleSubmit,
  error,
  submitting,
  form,
  zip,
  states,
}) => (
  <Page title="Edit Patient">
    <div className="row-fluid">
      <div className="span12">
        <Link to={`/a/portal/patient_members/${persistedPatientMember.id}`}>
          &lt;&lt; Back to Patient
        </Link>
      </div>
    </div>
    <PatientMemberHeader patientMember={persistedPatientMember} />
    <Row>
      <Widget
        className="nopadding"
        title="Edit Patient - Please fill in all fields on this form"
        span={12}
      >
        <HForm onSubmit={handleSubmit}>
          <Errors errors={error || []} />
          <TextField name="medicalRecordNumber" label="Patient MRN" />
          <TextField name="patientAttributes.lastName" label="Patient Last Name" />
          <TextField name="patientAttributes.firstName" label="Patient First Name" />
          <DateMaskField
            name="patientAttributes.dobString"
            label="Patient DOB"
            mask="dob"
            placeholder="mm/dd/yyyy"
          />
          <PhoneMaskField
            name="patientAttributes.formattedPrimaryPhone"
            label="Patient Primary Phone"
          />
          <PhoneMaskField
            name="patientAttributes.formattedSecondaryPhone"
            label="Patient Secondary Phone"
          />
          <RadioGroupField
            name="patientAttributes.consentToTextMessage"
            label="Does the patient consent to receiving care-related (SMS) text messages?"
            options={[
              { value: true, label: 'Yes' },
              { value: false, label: 'No' },
            ]}
          />
          <TextField name="formattedSsn" label="Patient SSN" />
          <PatientCoverageForm form={form} prefix="patientAttributes.patientCoverageAttributes" />
          <TextField
            name="patientAttributes.zip"
            label="Patient Zip"
            className="input-small"
            placeholder="zip code"
          />
          <PlainCountySelectionField
            className="input-xlarge"
            name="patientAttributes.fipsCode"
            label="Patient County"
            zip={zip}
          />
          <TextField
            name="patientAttributes.streetAddress"
            label="Patient Street Address"
            className="input-medium"
            placeholder="address"
          />
          <TextField
            name="patientAttributes.streetAddressLine2"
            label="Street Address (Line 2)"
            className="input-medium"
            placeholder="suite"
          />
          <TextField
            name="patientAttributes.city"
            label="Patient City"
            className="input-medium"
            placeholder="city"
          />
          <PlainSelectField
            name="patientAttributes.stateId"
            label="Patient State"
            className="input-medium"
            options={states}
            valueKey="id"
            labelKey="name"
          />
          <PlainSelectField
            name="patientActiveStatusId"
            label="Patient Active"
            options={patientActiveStatuses}
            labelKey="name"
            valueKey="id"
          />
          <Field
            name="patientActiveStatusId"
            render={({ input: { value } }) => {
              const patientActiveStatus = patientActiveStatuses.find(s => s.id === value);
              if (patientActiveStatus && patientActiveStatus.name === 'No - Other') {
                return (
                  <TextField
                    name="patientStatusNote"
                    label="Patient Status Note"
                    className="input-large"
                  />
                );
              }
              return null;
            }}
          />
          <div className="form-actions">
            <SpinnerButton type="submit" className="btn btn-primary" loading={submitting}>
              Save
            </SpinnerButton>
          </div>
        </HForm>
      </Widget>
    </Row>
  </Page>
);

const mapStateToProps = (state, ownProps) => {
  const zip = formValueSelector(ownProps.form)(state, 'patientAttributes.zip');
  return {
    zip,
  };
};

const FormifiedPresentationComponent = reduxForm({})(
  connect(mapStateToProps)(PresentationComponent)
);

export default Show;
